/**
 * Icon names the API sends, resolved to components.
 *
 * `DashboardMetrics` returns `icon: 'rupee' | 'bag' | 'chart' | …` per KPI and
 * per activity row rather than markup, so the backend can add a tile without a
 * frontend release. An unknown name falls back to a neutral dot instead of
 * rendering nothing — a KPI with a missing icon should still be a KPI.
 */

import type { ReactNode } from 'react'
import {
  BagIcon,
  CardIcon,
  ChartIcon,
  CircleIcon,
  RefreshIcon,
  RupeeIcon,
  ShieldIcon,
  StoreIcon,
  TruckIcon,
  UsersIcon,
  WalletIcon,
} from './icons.js'

const REGISTRY: Record<string, (props: { size?: number }) => ReactNode> = {
  rupee: RupeeIcon,
  bag: BagIcon,
  chart: ChartIcon,
  card: CardIcon,
  cod: TruckIcon,
  shield: ShieldIcon,
  refresh: RefreshIcon,
  store: StoreIcon,
  users: UsersIcon,
  wallet: WalletIcon,
}

export function IconByName({ name, size = 20 }: { name: string; size?: number }): ReactNode {
  const Component = REGISTRY[name] ?? CircleIcon
  return <Component size={size} />
}
